import axios from "axios";

export default {
  methods: {
    casjump(address) {
      let ticket = localStorage.getItem("casticket");
      if (ticket) {
        GMS.util
          .checkTGT()
          .then(res => {
            if (res) {
              this.getCasSt(address);
            } else {
              this.$router.push("/login");
            }
          })
          .catch(() => {
            this.$router.push("/login");
          });
      } else {
        this.$router.push("/login");
      }
    },
    getCasSt(address) {
      let url = encodeURI(address);
      let TGT = localStorage.getItem("TGT");
      if (TGT) {
        var config = {
          method: "post",
          url: `${window.osConfig.ossUrl}/cas/v1/tickets/${TGT}?service=${url}`,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded"
          },
          data: {}
        };
        axios(config)
          .then(function(response) {
            let locationUrl = `${address}?ticket=${response.data}`;
            if (locationUrl.indexOf("/#/") === -1) {
              locationUrl = `${address}/#/?ticket=${response.data}`
            }
            window.open(locationUrl);
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/casjump.js